import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';

import {NbSortingItemComponent} from './nb-sorting-item.component';
import {NbSortingComponent} from './nb-sorting.component';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    NbSortingComponent,
    NbSortingItemComponent,
  ],
  providers: [
  ],
  exports: [
    NbSortingComponent,
    NbSortingItemComponent,
  ],
})
export class NbSortingModule {}
